import { colors } from '../../styles/colors';
import styled, { css, keyframes } from 'styled-components';
import { LoaderProps } from './types';

const SpinLoader = keyframes`
    0% {transform: rotate(45deg);}
    20% {transform: rotate(45deg);}
    60% {transform: rotate(405deg);}
    100%{transform: rotate(405deg);}
`;

const ChangeColorLoader = keyframes` 
    0% {background-color: transparent;}
    10% {background-color: transparent;}
    30% {background-color: var(${colors['primary/1000']});}
    60% {background-color: var(${colors['primary/1000']});}
    80% {background-color: transparent;}
    100% {background-color: transparent;}
`;

export const TabLoader = styled.div`
  position: absolute;
  border: solid 1px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  &:nth-child(1),
  &:nth-child(2),
  &:nth-child(3),
  &:nth-child(4) {
    border-color: var(${colors['primary/1000']});
  }
  &:nth-child(1) {
    top: -100%;
  }
  &:nth-child(2) {
    right: -100%;
  }
  &:nth-child(3) {
    bottom: -100%;
  }
  &:nth-child(4) {
    left: -100%;
  }
  animation: ${ChangeColorLoader} 4s infinite;
`;

const loaderIsVisible = css`
  opacity: 1;
  visibility: visible;
`;

const loaderIsNotVisible = css`
  opacity: 0;
  visibility: hidden;
`;

const loaderOverlay = (isTransparent?: boolean) => css`
  background-color: ${isTransparent
    ? 'transparent'
    : `var(${colors['neutral/white']})`};
  top: 0;
  left: 0;
  z-index: 9999;
`;

export const LoaderWrapper = styled.div<LoaderProps>`
  width: 100%;
  min-height: 200px;
  transition: all 0.2s;
  position: ${({ isFull, isAbsolute }) =>
    isFull ? 'fixed' : isAbsolute ? 'absolute' : 'relative'};
  ${({ isFull, isAbsolute, isTransparent }) =>
    (isFull || isAbsolute) && loaderOverlay(isTransparent)};
  ${({ isVisible }) => (isVisible ? loaderIsVisible : loaderIsNotVisible)};
  ${({ isFull, isAbsolute }) =>
    isFull || isAbsolute ? `height: 100%` : '200px'};
`;

export const LoaderStyled = styled.div`
  position: absolute;
  display: block;
  width: 50px;
  height: 50px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  transform: rotate(45deg);
  animation: ${SpinLoader} 2s infinite, ${ChangeColorLoader} 4s infinite;
  &::before,
  &::after {
    content: '';
    position: absolute;
    background-color: transparent;
    z-index: 1;
  }
  &::before {
    width: 300%;
    height: 100%;
    left: -100%;
  }
  &::after {
    top: -100%;
    width: 100%;
    height: 300%;
  }
`;
